import React from 'react';
import S from './ListeDeroulante.module.scss';

const ListeDeroulante = ({
  value = '',
  onChange = () => {},
  options = [],
  placeholder = 'Sélectionnez une option',
  disabled = false,
  required = false,
  name = '',
  id = '',
  className = '',
  ...props
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <select
      value={value}
      onChange={handleChange}
      disabled={disabled}
      required={required}
      name={name}
      id={id}
      className={[S.listeDeroulante, className].join(' ')}
      {...props}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option, index) => (
        <option key={index} value={option.value || option}>
          {option.label || option}
        </option>
      ))}
    </select>
  );
};

export default ListeDeroulante;
